import { render } from "./Rules.vue?vue&type=template&id=e67ae19a&scoped=true&bindings={\"maps\":\"setup\",\"selected\":\"setup\",\"selectMap\":\"setup\",\"resetMaps\":\"setup\",\"t\":\"setup\"}"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"

import "./Rules.vue?vue&type=style&index=0&id=e67ae19a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e67ae19a"

export default script